export const queryKeys = {
  CITY_PROBLEMS_VIEW: "city-problems-view",
  CITY_DETAILED_PROBLEM: "city-detailed-problem",
  CITY_ORGANIZATIONS_SELECT: "city-organizations-select",
}